import { useQuery } from 'react-query';
import { MARKET_STATS_CACHE_KEY } from '../../Constants';
import { fetchMarketStats } from '../../services/marketstats.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (type) => useQuery<any, Error>([MARKET_STATS_CACHE_KEY, type], async () => fetchMarketStats(type));
